import React, { useEffect, useState } from "react";
import { icons } from "../../assets/icons";
import { assetGifCharacter } from "../../assets/charactergifs";
import ObserverEmitter, { EVENTS } from "../../emitter/Observer";
import { audiosAssets } from "../../assets/audio";

const namesCharactes = {
	"1": "andatti",
	"2": "cel",
	"3": "premia",
	"4": "spin",
}

export const ValidationResultModal = ({ isCorrect = false, title = "", dialogModal = "", buttonTxt = "", action = () => { }, numberPoints = 0 }) => {
	const [imgStatus, setImgStatus] = useState("")
	useEffect(() => {
		const selectCharacter = localStorage.getItem("character") ?? "1"
		const name = namesCharactes[selectCharacter]
		if (!name) {
			return
		}
		const { festejo, pena } = assetGifCharacter[name]
		if (isCorrect) {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.cards.cardFine)
			setImgStatus(festejo)
		} else {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.cards.cardMalHecho)
			setImgStatus(pena)
		}
	}, [isCorrect])

	return (
		<div className="fixed z-30 top-0 w-full h-full bg-black bg-opacity-20 flex justify-center items-center">
			<div
				className={`relative w-[272px] h-[312px] md:w-[464px] md:h-[552px] py-2 md:py-8 border-white overflow-hidden border-[4px] bg-cover bg-no-repeat bg-center rounded-3xl  ${isCorrect ? "bg-backfeedbackGreen" : "bg-backfeedbackRed"
					}`}
			>
				<div className={`absolute z-10 h-[65px] md:h-[70px] w-[30%] right-4 top-1/2 -translate-y-1/2 ${numberPoints === 0 && "hidden"}`}>
					<div className="h-full w-full flex justify-center items-center gap-1">
						<div className="flex items-center gap-1 font-bold textShadowValidationError">
							<span className="text-[14px] md:text-[28px] text-white ">+</span>
							<span className="text-[20px] md:text-[48px] text-white">{numberPoints}</span>
							<span className="text-[14px] md:text-[24px] self-end text-white">pts.</span>
						</div>
					</div>
				</div>
				<div className="h-[40px] md:h-[60px] w-full py-2 flex justify-center items-center">
					<div className="h-full w-full">
						<img className="h-full w-full" src={icons.logooxxo} alt="oxxo" />
					</div>
				</div>
				<div className="h-[55px] md:h-[75px] w-full flex justify-center items-center">
					<p className="text-white text-[18px] md:text-[30px] font-bold">{title}</p>
				</div>
				<div className="h-[96px] md:h-[205px] w-full">
					<div className="h-full w-full">
						{/* <img className="h-full w-full object-contain" src={imgs.personGame} alt="persongame" /> */}
						<img className="h-full w-full object-contain" src={imgStatus} alt="persongame" />
					</div>
				</div>
				<div className="h-[50px] md:h-[90px] w-full px-4">
					<div className="h-full w-full bg-[#00000074] px-2 md:px-4 py-1 rounded-lg md:rounded-2xl flex items-center">
						<p className="text-white text-[10px] md:text-[16px] font-semibold">{dialogModal}</p>
					</div>
				</div>
				<div className="h-[50px] md:h-[60px] w-full py-1.5 px-2 md:px-[100px] md:py-2.5">
					<div onClick={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.barraNavegacion.completeNavigation)
						action()
					}} className="cursor-pointer boxShadowButtons h-full w-full bg-[#FFC427] flex justify-center items-center rounded-lg md:rounded-xl">
						<p className="text-white text-[20px] font-semibold">{buttonTxt}</p>
					</div>
				</div>
			</div>
		</div>
	);
};
